



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Group } from '../../models/group.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../services/alert.service';
import { CreateEditGroupModalComponent } from './create-edit-group-modal/create-edit-group-modal.component';
import { Router } from '@angular/router';
import { GroupProductModalComponent } from './group-product-modal/group-product-modal.component';
import { AccountService } from '../../services/account.service';
import { Permission } from '../../models/permission.model';
import { Angular5Csv } from '../../../../node_modules/angular5-csv/dist/Angular5-csv';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'groups',
    template: require('./groups.component.html'),
    styles: [require('./groups.component.css')],
    animations: [fadeInOut]
})
export class GroupsComponent {
    groups: Group[];
    writeGroupsPermission = Permission.writeGroupsPermission;
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService, public accountService: AccountService) {
        this.getGroups();
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

    getGroups() {
        this.apiService.getGroups().subscribe(r => {
            this.groups = r;
        })
    }

    createEditGroupProduct(group: any) {
        let dialogRef = this.dialog.open(GroupProductModalComponent, {
            width: '600px',
            data: {
                group: group,
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getGroups();
        })
    }

    createEditGroup(group: any) {
        let dialogRef = this.dialog.open(CreateEditGroupModalComponent, {
            width: '600px',
            data: {
                currentGroup: group || {},
                //vendors: this.groups
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getGroups();
        })
    }

    deleteGroup(groupId: number) {
        this.alertService.showDialog("Do you want to delete this Group ?", DialogType.confirm, val => {

            this.apiService.deleteGroup(groupId).subscribe(r => {
                this.getGroups();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/groups/'+ event.row.groupId]);
        }
    }

    downloadCsv() {
        var csv = new Angular5Csv(_.map(this.groups, g => { return { 'groupId': g.groupId, 'groupName': g.groupName }; }),
            'LA_Sponsor_csv_' + moment().format('YYYY-MM-DD'),
            {
                'showLabels': true, headers: ["Sponsor Id", "Sponsor Name"],
            });
        console.log(csv)
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/groups/groups.component.ts